import type { MessageKey } from '../../../configuration';
import type { Tenant } from '../common/utils/tenants';

export interface TabInfo {
    componentName: CustomerCenterTab;
    limitedToTenants: Tenant[];
    requiredPermissions: string[];
    labelId: MessageKey;
}

// biome-ignore lint/style/noEnum: Preserve the established enum values and runtime API used by existing callers
export enum CustomerCenterTab {
    SERVICES = 'SERVICES',
    BOOKINGS = 'BOOKINGS',
    BOOKINGS_OVERVIEW = 'BOOKINGS/OVERVIEW',
    ASSETS = 'ASSETS',
    CONTRACTS = 'CONTRACTS',
    INVOICES = 'INVOICES',
    HISTORY = 'HISTORY',
    PAYMENT_METHODS = 'PAYMENTMETHODS',
    USAGE = 'USAGE',
    FREE_TRIAL = 'FREETRIAL',
    PROFILE = 'PROFILE',
    PARTNERS = 'PARTNERS',
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
    COMPANY_SETTINGS = 'COMPANY',
    BILLING = 'BILLING',
    BILLING_INVOICES = 'BILLING/INVOICES',
    BILLING_USAGE = 'BILLING/USAGE',
    BILLING_PAYMENT_METHOD = 'BILLING/PAYMENT-METHOD',
}
